var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-portlet kt-portlet--height-fluid"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-widget4"},[_c('h4',[_vm._v("Invalid Request")]),_vm._v("\n\n      You can close this window.\n    ")])])])
}]

export { render, staticRenderFns }